import { AxiosError } from 'axios';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import Button from '../../../rxlib/components/buttons/button';
import ItemLicencaExclusao from '../../item-licenca/exclusao';
import InputLabel from '../../../rxlib/components/input-label';
import { ApiError, ListagemProps } from '../../../services/tipos';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import ButtonLink from '../../../rxlib/components/buttons/button-link';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import { obterQuantidadeParaPular, tratarErroApi } from '../../../rxlib/services/utilitarios';

interface Filtros {
    nomeChave: string;
}

function obterFiltrosDaQuery(search: string): Filtros {
    const params = new URLSearchParams(search);

    return {
        nomeChave: params.get('nomeChave') ?? '',
    };
}

function montarQueryString(filtros: Filtros): string {
    const params = new URLSearchParams();

    if (filtros.nomeChave !== '') {
        params.set('nomeChave', filtros.nomeChave);
    }

    const queryString = params.toString();
    return queryString !== '' ? `?${queryString}` : '';
}

function ItemLicencaListagem(props: ListagemProps) {
    const [exclusao, setExclusao] = useState<boolean>(false);
    const [itensLicenca, setItensLicenca] = useState<[{}]>([{}]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [idItemLicenca, setIdItemLicenca] = useState<string>('');
    const [token] = useState(useAppSelector(state => state.token));
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [showExclusao, setShowExclusao] = useState<boolean>(false);
    const [quantidadeTotal, setQuantidadeTotal] = useState<number>(0);
    const [messageWarning, setMessageWarning] = useState<string[]>([]);

    const [filtros, setFiltros] = useState<Filtros>(
        () => obterFiltrosDaQuery(props.location.search)
    );

    const { register, handleSubmit } = useForm<Filtros>();

    const handleHide = () => setShowWarning(false);

    const handleHideExclusao = () => setShowExclusao(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Itens da licença', link: '' },
    ];

    const configuracoesTabela: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Nome', campo: 'Nome', tipo: 'string' },
            { nome: 'Chave', campo: 'Chave', tipo: 'string' },
            { nome: 'Tipo de controle', campo: 'TipoControle', tipo: 'tipoControle' },
        ],
    }

    const quantidadeRegistrosPorPagina = 10;
    const quantidadeParaPular = obterQuantidadeParaPular(parseInt(props.match.params.pagina), quantidadeRegistrosPorPagina);

    const temPermissao = usuarioTemPermissao(token, 'itens_licenca_visualizar');
    const linkNovo = usuarioTemPermissao(token, 'itens_licenca_novo') ? '/itemlicenca/novo' : '';
    const linkEdicao = usuarioTemPermissao(token, 'itens_licenca_editar') ? '/itemlicenca/editar' : '';
    const handleExclusao = usuarioTemPermissao(token, 'itens_licenca_excluir') ? handleExcluir : undefined;

    useEffect(() => {
        const filtrosQuery = obterFiltrosDaQuery(props.location.search);

        if (filtros.nomeChave !== filtrosQuery.nomeChave) {
            setFiltros(filtrosQuery);
        }
    }, [props.location.search, filtros.nomeChave]);

    useEffect(() => {
        if (temPermissao) {
            setCarregando(true);

            let request = `/OData/ItemLicenca?$count=true&$top=${quantidadeRegistrosPorPagina}&$skip=${quantidadeParaPular}`;
            if (filtros.nomeChave !== '') {
                request = `/OData/ItemLicenca?$count=true&$top=${quantidadeRegistrosPorPagina}&$skip=${quantidadeParaPular}&$filter=(contains(toupper(nome),toupper('${filtros.nomeChave}')) or contains(toupper(chave),toupper('${filtros.nomeChave}')))&`;
            }

            api.get(request)
                .then(response => {
                    setTimeout(() => {
                        setQuantidadeTotal(response.data['@odata.count']);
                        setItensLicenca(response.data.value);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
        }
    }, [quantidadeParaPular, temPermissao, exclusao, filtros]);

    function handleExcluir(id: string) {
        setIdItemLicenca(id);
        setShowExclusao(true);
    }

    const onSubmit: SubmitHandler<Filtros> = data => {
        const filtrosAtualizados: Filtros = {
            nomeChave: data.nomeChave.trim(),
        };

        props.history.push({
            pathname: '/itemlicenca',
            search: montarQueryString(filtrosAtualizados),
        });
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>Listagem de itens da licença</h6>
                            </div>
                        </div>
                        <div className='row px-1 mt-2'>
                            <div className='col-5'>
                                {
                                    carregando
                                        ? ''
                                        : <InputLabel
                                            type='text'
                                            maxLength={50}
                                            placeholder=''
                                            readOnly={false}
                                            autoFocus={true}
                                            required={false}
                                            name='nomeChave'
                                            id='inputNomeChave'
                                            defaultValue={filtros.nomeChave}
                                            className='rxlib-input-label-coluna'
                                            key={`nomeChave-${filtros.nomeChave}`}
                                            referencia={register({ required: false })}
                                            label='Pesquisar por nome ou chave do item da licença:' />
                                }
                            </div>
                            <div className='col-2 rxlib-celula-botao'>
                                {
                                    carregando
                                        ? ''
                                        : <Button
                                            type='submit'
                                            texto='Pesquisar'
                                            classStyle='btn-rxlib' />
                                }
                            </div>
                            <div className='col-3'></div>
                            <div className='col-2 ps-3 rxlib-celula-botao'>
                                {
                                    carregando
                                        ? ''
                                        : <ButtonLink
                                            texto='Novo'
                                            link={linkNovo}
                                            classStyle='btn-rxlib' />
                                }
                            </div>
                        </div>
                        <div className='row ps-3 mt-2'>
                            <div className='row px-1'>
                                <Listagem
                                    campoId='Id'
                                    className='px-1'
                                    usarOrdenacao={true}
                                    tipoBotaoAcao='button'
                                    listagemDetalhe={false}
                                    carregando={carregando}
                                    linkEdicao={linkEdicao}
                                    fonteDados={itensLicenca}
                                    onExcluir={handleExclusao}
                                    linkListagem='/itemlicenca'
                                    queryString={props.location.search}
                                    configuracoesTabela={configuracoesTabela}
                                    quantidadeTotalRegistros={quantidadeTotal}
                                    linkVisualizacao='/itemlicenca/visualizar'
                                    paginaAtual={parseInt(props.match.params.pagina)}
                                    quantidadeRegistrosPorPagina={quantidadeRegistrosPorPagina} />
                            </div>
                        </div>
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <ItemLicencaExclusao
                    show={showExclusao}
                    tratarErro={tratarErro}
                    onExcluir={setExclusao}
                    onHide={handleHideExclusao}
                    idItemLicenca={idItemLicenca} />
            </RxlibLayout>
        </>
    );
}

export default ItemLicencaListagem;